import React from 'react'
import { BrowserRouter } from 'react-router-dom'
import { createRoot } from 'react-dom/client'

import { App } from './features/App'
import './i18n'
import reportWebVitals from './reportWebVitals'
import registerServiceWorker from './registerServiceWorker'

const container = document.getElementById('root')
if (container) {
  const root = createRoot(container)

  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  )
} else {
  console.error('Root container missing in index.html')
}

reportWebVitals()

registerServiceWorker()
